module.exports = __webpack_public_path__ + "img/nashville_24.1fcfd86f.png";